import { If, Modal, LockedProposals } from '@itau-loans-www/components'
import { useLead } from '@itau-loans-www/hooks'
import { isClient } from '@itau-loans-www/utils'
import classnames from 'classnames'

import Layout from '../layouts/Offer'
import Banner from './components/Banner'
import ConsigNCorModalContent from './components/ConsigNcorModalContent'
import FGTSModalContent from './components/FGTSModalContent'
import OtherProposals from './components/OtherProposals'
import RefinModalContent from './components/RefinModalContent'
import './offers.scss'

const Offers = () => {
  const {
    offerModalOpen,
    setOfferModalOpen,
    offerModalContent,
    leadData: { name, partner },
    offers: { hero, others, blocked },
    isPartner
  } = useLead()

  const offerlessChannel = !!hero?.offerlessChannel
  const hasHero =
    typeof hero?.productCode === 'string' && offerlessChannel !== true

  const isMarginComplementary =
    hero?.productCode === 'consig_comp_marg' ||
    others?.some(({ productCode }) => productCode === 'consig_comp_marg')

  const fgtsLabel =
    offerModalContent?.productCode === 'fgts_app'
      ? 'Finalizar no app Itaú'
      : 'Seguir para contratação'

  const classNamesModal = classnames('fgts-offers__modal', {
    'fgts-offers__modal--magalu': isClient() && isPartner('magalu'),
    'fgts-offers__modal--assai': isClient() && isPartner('assai'),
    'fgts-offers__modal--pirelli': isClient() && isPartner('pirelli'),
    'fgts-offers__modal--atacadao': isClient() && isPartner('atacadao'),
    'fgts-offers__modal--carrefour': isClient() && isPartner('carrefour'),
    'fgts-offers__modal--crediffato': isClient() && isPartner('crediffato'),
    'fgts-offers__modal--telhaNorte': isClient() && isPartner('telhaNorte')
  })

  return (
    <Layout isMarginComplementary={isMarginComplementary}>
      <div className="container">
        <Banner
          isMarginComplementary={isMarginComplementary}
          offerlessChannel={offerlessChannel}
          leadName={name}
          hasHero={hasHero}
          proposal={hero}
          partner={partner}
        />
        <div id="body-offers">
          <If
            condition={!partner && !isMarginComplementary}
            renderIf={<div className="offers__divider" />}
          />
          <If
            condition={others}
            renderIf={
              <OtherProposals
                offerlessChannel={offerlessChannel}
                proposals={others}
              />
            }
          />
          <If
            condition={blocked}
            renderIf={<LockedProposals proposals={blocked} />}
          />
        </div>

        <Modal
          type="pop"
          show={
            offerModalOpen &&
            offerModalContent?.productCode === 'consig_refin_inss_ncor'
          }
          className="refin-offers__modal"
          primary={{
            action: () => offerModalContent?.callback(),
            label: 'Seguir para contratação'
          }}
          secondary={{
            action: () => setOfferModalOpen(false),
            label: 'Voltar'
          }}
          onCloseClick={() => setOfferModalOpen(false)}
        >
          <RefinModalContent />
        </Modal>

        <Modal
          type="pop"
          show={
            offerModalOpen && offerModalContent?.productCode === 'consig_ncor'
          }
          className="consigNcor-offers__modal"
          onCloseClick={() => setOfferModalOpen(false)}
          primary={{
            action: () => offerModalContent?.callback(),
            label: 'Continuar'
          }}
          secondary={{
            action: () => setOfferModalOpen(false),
            label: 'Voltar'
          }}
        >
          <ConsigNCorModalContent />
        </Modal>

        <Modal
          type="pop"
          show={
            offerModalOpen &&
            ['FGTS', 'fgts_app'].includes(offerModalContent?.productCode)
          }
          onCloseClick={() => setOfferModalOpen(false)}
          className={classNamesModal}
          primary={{
            action: () => offerModalContent?.callback(),
            label: fgtsLabel
          }}
          secondary={{
            action: () => setOfferModalOpen(false),
            label: 'Voltar'
          }}
        >
          <FGTSModalContent />
        </Modal>
      </div>
    </Layout>
  )
}

export default Offers
